import baseStore from '../generic_store';

const base = baseStore('units');

const state = {
    ...base.state,
    base_url: '/api/units',
    resourceName: 'Unité',
    model: {
        name: null,
        status: null,
        surface: null,
        price: null,
        description: {
            fr: null,
            en: null,
        },
        fullname: {
            fr: null,
            en: null,
        },
        price_detail: {
            fr:  null,
            en: null,
        },
        translatable: {
            description: {
                fr: null,
                en: null,
            },
            fullname: {
                fr: null,
                en: null,
            },
            price_detail: {
                fr: null,
                en: null,
            },
        }
    },
};

const getters = {
    ...base.getters,
};

const actions = {
    ...base.actions,
};

const mutations = {
    ...base.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

